import {useMutation, useQueryClient} from '@tanstack/react-query';
import {UseFormReturn} from 'react-hook-form';
import {apiClient} from '@common/http/query-client';
import {toast} from '@common/ui/toast/toast';
import {useTrans} from '@common/i18n/use-trans';
import {onFormQueryError} from '@common/errors/on-form-query-error';
import {message} from '@common/i18n/message';
import {BackendResponse} from '@common/http/backend-response/backend-response';
import { LoanProduct } from '@app_modules/loan-products/loan-product';

interface Response extends BackendResponse {
  loanProduct: LoanProduct;
}

export interface LoanProductPayload {
  name: string;
  active: boolean;
  // lender_ids: string;
  // document_category: string;
}

export function useUpdateLoanProduct(
  id: string|number,
  form: UseFormReturn<LoanProductPayload>,
) {
  const {trans} = useTrans();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: LoanProductPayload) => updateLoanProduct(id, payload),
    onSuccess: async () => {
      await queryClient.invalidateQueries({queryKey: ['loan-products']});
      toast(trans(message('Loan Product updated')));
    },
    onError: err => onFormQueryError(err, form),
  });
}

async function updateLoanProduct(
  id: string|number,
  payload: LoanProductPayload,
) {
  return apiClient
    .put<Response>(`loan-products/${id}`, payload)
    .then(r => r.data);
}
